import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RestInTheLord() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Rest in the Lord, trust Him completely, and wait patiently for Him" />
        <blockquote>
          “Commit your way to the Lord, Trust also in Him, and He will do it. Rest in the Lord and wait patiently for Him…” (Psalm 37:5,7)
        </blockquote>

        <p>How many times do we sin because we are impatient about something, or want someone to change, or want to force something to happen that should be left alone? We want what we want when we want it, and this attitude can easily lead to sin. Saul lost the kingdom because he was too impatient to wait for Samuel (1 Samuel 13:1-14). God wants us to learn to trust matters to Him, to let His power be perfected in our weaknesses. What Paul is talking about is physical weakness or weakness in not being able to control the circumstances or the things going on around us; he is not talking about being spiritually weak, or weak in faith, or weak in obedience to God’s commandments. Learn to overcome the temptation of impatience, of trying to force things to happen or make people do things. We often cannot control our circumstances or the behaviors and choices of others. The real challenge, and joy when we are successful, is to get ourselves under control, and become fully obedient to the Lord in all He has asked us to do. Only then will we begin to see real changes in us and those around us as we see God’s power at work, doing greater and more lasting things than we could ever do ourselves. Rest in the Lord. Learn to trust Him with all cares and difficult circumstances. Learn to wait for His timing and wait for Him to fulfill your needs, and this fulfillment and His fellowship will be far better than a lifetime of sin.</p>
        <br />

        <ul>
          <li>
            <strong>Commit all burdens, concerns, frustrations, and irritations to God.</strong><br />
            <em>Job 13:15, Psalm 25:15, 46:10, Isaiah 30:15, Matthew 11:28-30, 1 Peter 5:6-7</em>
          </li>
          <br />
          <li>
            <strong>Purpose to wait for God to act; wait for God’s timing.</strong><br />
            <em>Psalm 27:14, 37:5-7, 40:1-2, 62:5, 130:5-6, 147:11, Proverbs 3:5-6, Isaiah 40:31</em>
          </li>
          <br />
          <li>
            <strong>Refuse to be anxious or fret or angry.</strong><br />
            <em>Psalm 37:7-8, 42:5-11, Matthew 6:25-34, Philippians 4:6-7</em>
          </li>
          <br />
          <li>
            <strong>Let God’s power be perfected and made known through your weakness.</strong><br />
            <em>1 Corinthians 1:25, 2 Corinthians 12:7-10</em>
          </li>
          <br />
          <li>
            <strong>Rejoice in what He is teaching you through your difficult circumstances.</strong><br />
            <em>Philippians 4:4, 12-13, James 1:12, 1 Peter 1:6-9</em>
          </li>
          <br />
          <li>
            <strong>Acknowledge the Lord, boast in God, and make Him your strength.</strong><br />
            <em>1 Samuel 17:37, 45-47, Psalm 20:5-7, 34:1-3, 44:8, 46:1, Proverbs 3:5-6, Jeremiah 9:23-24</em>
          </li>
          <br />
          <li>
            <strong>Do not retaliate or take revenge in any way.</strong><br />
            <em>Proverbs 20:22, 24:29, Romans 12:17-21</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
